module.exports = __webpack_public_path__ + "static/img/money_gif.6a0aacc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/money_gif.gif
// module id = C1OT
// module chunks = 1